export { palette } from 'reakit-system-palette/palette';
